import { List, ListItem, Typography } from '@mui/material'
import { defaultOverrides, MuiMarkdown } from 'mui-markdown'
import { FC, PropsWithChildren } from 'react'

export const SippMarkdown: FC<PropsWithChildren> = ({ children }) => {
  return (
    <MuiMarkdown
      overrides={{
        ...defaultOverrides,
        h1: {
          component: Typography,
          props: {
            style: { fontSize: '24px', margin: '8px 0' },
          },
        },
        h2: {
          component: Typography,
          props: {
            style: { fontSize: '20px', margin: '8px 0' },
          },
        },
        h3: {
          component: Typography,
          props: {
            style: { fontSize: '18px', margin: '8px 0' },
          },
        },
        ul: {
          component: List,
          props: {
            disablePadding: true,
            style: { listStyleType: 'none' },
          },
        },
        li: {
          component: ListItem,
          props: {
            style: {
              display: 'inline-block',
              padding: '4px 1rem',
            },
          },
        },
      }}
    >
      {children}
    </MuiMarkdown>
  )
}
